import * as React from "react";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
export const RowContentStyles = css(
  ({ theme }) => css`
    background-color: ${theme.colors.global.contentBackground};
    margin-bottom: ${theme.spacings.xs};
    border-radius: 6px;
    box-shadow: rgb(0 0 0 / 4%) 0 3px 5px;
  `
);
const StyledRow = styled.div`
  margin-left: -15px;
  margin-right: -15px;

  &::before,
  &::after {
    display: table;
    content: ' ';
  }

  &::after {
    clear: both;
  }

  &.content {
    ${RowContentStyles}
  }
`;
const Row = ({ children = void 0, as = void 0, ...rest }, ref) => /* @__PURE__ */ React.createElement(StyledRow, { ref, as, ...rest }, children);
export default forwardRef(Row);
